<template>
    <div>
        <section-banner-small :picture-url="bannerInfo.pictureUrl" :title="bannerInfo.title" :subtitle="bannerInfo.subtitle"></section-banner-small>

        <div>
            <loader v-if="loading" :radius="10" :stroke="2"></loader>

            <section v-if="!loading" class="section-style">
                <div data-aos="fade-left"
                     data-aos-offset="100"
                     data-aos-once="true"
                     data-aos-duration="500">

                    <classified-quotes :loading="loading"
                                       :all-recent-quotes="allRecentQuotes"
                                       :byNightsStay="byNightsStay"
                                       :by-budget="byBudget"
                                       :by-destination="byDestination"></classified-quotes>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import SectionBannerSmall from "./../components/sections/BannerSmall"
    import Loader from "./../components/misc/Loader"
    import ClassifiedQuotes from "./../components/misc/ClassifiedQuotes"

    export default {
        components: { ClassifiedQuotes, Loader, SectionBannerSmall },

        created() {
            this.initialize();
        },

        computed: {
            loading() {
                return this.$store.getters["Quotes/loading"]('festive');
            },
            allRecentQuotes() {
                return this.$store.getters["Quotes/data"]('festive');
            },
            byNightsStay() {
                return this.$store.getters["Quotes/byNightsStay"]('festive');
            },
            byBudget() {
                return this.$store.getters["Quotes/byBudget"]('festive');
            },
            byDestination() {
                return this.$store.getters["Quotes/byDestination"]('festive');
            },
            bannerInfo() {
                return {
                    pictureUrl: '/assets/bg/festive-bg.jpg',
                    title: 'Festive ' + this.festiveYear,
                }
            },
        },

        data: function () {
            return {
                festiveYear: (new Date()).getFullYear(),
            };
        },

        methods: {
            initialize() {
                this.$store.dispatch("Quotes/initializeData", 'festive')
            }
        }
    }
</script>
